import React from 'react';
function Error(props) {
    return (
        <span className="text-danger ml-1">{props.error}</span>
    );
}

export default Error;
